function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.cachedResults = {};
        this.input = this.querySelector('input[type="search"]');
        this.clearInput = this.querySelector('.js-close-search-input');
        this.predictiveSearchResults = this.querySelector('[data-predictive-search-results]');
		this.sectionId = 'predictive-search';
		this.mobileSearch = this.classList.contains('mobile-menu-search');
		if(this.mobileSearch){
			this.sectionId = 'predictive-search-mobile';
		}
        this.setupEventListeners();
    }

	handleClearSearch() {
		this.input.value = "";
		this.close();
		const headerSearchForm = document.querySelector('.js-header-search-form');
		if (headerSearchForm) {
			headerSearchForm.style.width = '25px';
			headerSearchForm.classList.remove('opened');
		}
	}

    setupEventListeners() {
        let _this = this;
        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 1200).bind(this));
		if(this.clearInput){
			this.clearInput.addEventListener('click',function (){
				_this.input.value = "";
				_this.close();
			})
		}

		document.addEventListener('click', (event) => {
          
			const headerSearchWrapper = document.querySelector('.header-search');
            const headerMobileMenu = document.querySelector('.header-mobile-menu');
			if (headerSearchWrapper && !headerSearchWrapper.contains(event.target) && headerMobileMenu && !headerMobileMenu.contains(event.target)) {
				this.handleClearSearch();
			}
		});
	}

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        // this.input.closest('.search-form').classList.add('loading');
        const searchTerm = this.getQuery();
        if (!searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(searchTerm);
    }

	setHistory(searchTerm){
		if(localStorage.getItem("PredictiveSearchHistory")){
			let history =JSON.parse(localStorage.getItem('PredictiveSearchHistory'));
			if(history.includes(`${searchTerm}`)){
				history.splice(history.indexOf(`${searchTerm}`), 1);
			}
			history.unshift(`${searchTerm}`)
			history = history.slice(0,10)
			localStorage.setItem('PredictiveSearchHistory', JSON.stringify(history));

		}else{
			let viewed_products = [`${searchTerm}`];
			localStorage.setItem('PredictiveSearchHistory', JSON.stringify(viewed_products));
		}

	}

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }
        fetch(`${ window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,query&${encodeURIComponent('resources[limit]')}=10&section_id=${this.sectionId}`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                    this.close();
                }
                return response.text();
            })
            .then((text) => {
                const doc = new DOMParser().parseFromString(text, 'text/html');
                const resultsMarkupHtml = doc.querySelector('[data-predictive-search-results]').innerHTML;
                if(resultsMarkupHtml.length > 0){
                    this.cachedResults[queryKey] = resultsMarkupHtml;
					if(!doc.querySelector('[data-predictive-search-results]').querySelector('.header-search-popup-empty-results')){
						this.setHistory(searchTerm);
					}
                    this.renderSearchResults(resultsMarkupHtml);
                }else{
                    this.close();
                }
            })
            .catch((error) => {
                throw error;
            });
    }

    renderSearchResults(resultsMarkupHtml) {
        if(resultsMarkupHtml.trim().length > 0) {
            // this.input.closest('.search-form').classList.remove('loading')
            this.predictiveSearchResults.innerHTML = resultsMarkupHtml;
			productCardSize();
			if(this.predictiveSearchResults.querySelector('.js-custom-scroll-bar')){
				new SimpleBar(this.predictiveSearchResults.querySelector('.js-custom-scroll-bar'));
			}
			this.renderHistory();
            this.open();
			productCardSize();
        }
    }
    open() {
		this.predictiveSearchResults.removeAttribute('style')
		if(this.mobileSearch){
			if(document.querySelector('.header-mobile-menu-list')){
				document.querySelector('.header-mobile-menu-list').classList.add('hidden')
			}
			if(document.querySelector('.header-mobile-menu-social-list')){
				document.querySelector('.header-mobile-menu-social-list').classList.add('hidden')
			}
			if(document.querySelector('#header-mobile-menu')){
				document.querySelector('#header-mobile-menu').classList.add('open-search')
			}
            if(document.querySelector('.mobile-menu-search-grid ')){
    			document.dispatchEvent(new CustomEvent("swym:mobile-predictive-search-loaded"));
    		}
		}else{
          if(document.querySelector('.header-search-popup-results-grid')){
			document.dispatchEvent(new CustomEvent("swym:predictive-search-loaded"));
		}
        }

    }

    close(clearSearchTerm = false) {
		this.predictiveSearchResults.innerHTML = ""
		this.predictiveSearchResults.style.display = "none"
		if(this.mobileSearch){
			if(document.querySelector('.header-mobile-menu-list')){
				document.querySelector('.header-mobile-menu-list').classList.remove('hidden')
			}
			if(document.querySelector('.header-mobile-menu-social-list')){
				document.querySelector('.header-mobile-menu-social-list').classList.remove('hidden')
			}
			if(document.querySelector('#header-mobile-menu')){
				document.querySelector('#header-mobile-menu').classList.remove('open-search')
			}
		}
    }
	renderHistory(){
		if(localStorage.getItem("PredictiveSearchHistory")){
			let history =JSON.parse(localStorage.getItem('PredictiveSearchHistory'));
			let historyHtml = ``
			history.forEach(item=>{
				historyHtml += `
					<li class="header-search-popup-suggestion-list-item">
						<a href="${window.routes.search_url}?q=${item}&type=product">${item}</a>
					</li>
				`
			})
			if(this.predictiveSearchResults.querySelector('.header-search-popup-suggestion-list')){
				this.predictiveSearchResults.querySelector('.header-search-popup-suggestion-list').innerHTML = historyHtml;
			}
		}
	}
}
customElements.define('predictive-search', PredictiveSearch);
